export default __webpack_public_path__ + "static/media/RUFOS.9681bb79.png";